let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lRtGG")).then(() => parcelRequire('4ayWZ'));